// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import AnalysisExportModal from '../analysis/AnalysisExportModal'
import {MenuItem} from 'ui'
import DropdownHeader from './DropdownHeader'

const AnalysisHeader = (props) => {
  const { projectID } = useParams();
  const [showExportModal, setShowExportModal] = useState(false);

  const dropdownOptions = [
    <MenuItem eventKey="1" onClick={() => setShowExportModal(true)}>
            Export Options
    </MenuItem>
  ];

  return (
    <div>
      <AnalysisExportModal
        show={showExportModal}
        projectId={projectID}
        onHide={() => setShowExportModal(false)}
      />
      <DropdownHeader
        dropdownOptions={dropdownOptions}
        projectId={projectID}
        hasEditPermission={props.hasEditPermission}
        onShowCollabModal={props.onShowCollabModal}
        showCollabModal={props.showCollabModal}
      >
        Snippets
      </DropdownHeader>
    </div>
  )
}

export default AnalysisHeader;
